/*=========================================================================================
  File Name: module-import-actions.js
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import SupplierAPI from '@/api/SupplierAPI.js';
import DownloadAPI from '@/api/DownloadAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';
import ImportAPI from '../../api/ImportAPI';
import { debug } from 'util';

export default {
	/**
	 * Thực hiện lấy các cột trong file nhập khẩu
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 * @author dqduy 13.08.2024
	 */
	importColumn: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ImportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/importcolumn/${payload.importType}`,
				params: payload
			},
			true
		);
		return res;
	},

	/**
	 * Bước validate trước khi thực hiện lấy dữ liệu nhập khẩu
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 * @author dqduy 13.08.2024
	 */
	validateImportData: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ImportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/validatedata/${payload.ImportType}`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Tải file kết quả nhập khẩu
	 * @author dqduy 12.08.2024
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	exportSupplierResultImport: async function(context, payload) {
		let fileName = 'KetQua_NhapKhau_MaNCC_KhachHang.xlsx';
		if (payload && payload.FileName) {
			fileName = payload.FileName;
		}
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let tryTime = 0;
		async function download(key) {
			tryTime++;
			let exportFile = await httpClient.getAsync({
				url: ImportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/downloadfile/${key}`,
				responseType: 'arraybuffer',
				onDownloadProgress: function(progressEvent) {
					if (progressEvent.total) {
						var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
						ProgressData = {
							percentCompleted: percentCompleted,
							fileName: fileName,
							Success: true
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					}
				}
			});
			//emit event
			EventBusGlobal.$emit(GlobalEventName.UpdateIsDownload);
			if (exportFile instanceof ArrayBuffer) {
				ProgressData = {
					percentCompleted: 100,
					fileName: fileName,
					Success: true
				};
				EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
				commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
			} else {
				if (tryTime >= NumberRetry) {
					ProgressData = {
						percentCompleted: 0,
						fileName: fileName,
						Success: false
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					return;
				}
				setTimeout(() => {
					download(key);
				}, NumberTimeOutRetry);
			}
		}
		setTimeout(() => {
			download(payload.CacheKeyDownloadResult);
		}, NumberTimeOutRetry);
		return true;
	},

	/**
	 * Tải lại file lần nữa
	 * @author dqduy 12.08.2024
	 * @param {*} context
	 * @param {*} payload
	 */
	downloadResultAgain: async function(context, payload) {
		let ProgressData = {
			percentCompleted: 0,
			fileName: payload.FileName,
			Success: true
		};
		let exportFile = await httpClient.getAsync({
			url:
				ImportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) +
				`/downloadfileagain/${payload.CacheKeyDownloadResult}`,
			responseType: 'arraybuffer',
			onDownloadProgress: function(progressEvent) {
				if (progressEvent.total) {
					var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
					ProgressData = {
						percentCompleted: percentCompleted,
						fileName: payload.FileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
				}
			}
		});
		ProgressData = {
			percentCompleted: 100,
			fileName: payload.FileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', payload.FileName);
	},

	/**
	 * Tải tệp mẫu
	 * @author dqduy 12.08.2024
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	uploadFilePattern: async function(context, payload) {
		let fileName = 'Nhap_khau_NCC.xlsx';
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.getAsync({
			url: ImportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/requestfiletemple/${payload.ImportType}`
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: ImportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/downloadfile/${key}`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},

	/**
	 * thực hiện nhập khẩu khi đã có dữ liệu
	 * @author dqduy 13.08.2024
	 */
	importDataToSupplier: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url:
					ImportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) +
					`/${payload.ImportType}/${payload.CacheKeyImportData}`,
				data: payload
			},
			true
		);
		return res;
	}
};
